let Backbone = require("backbone");
let MenuItemModel = require("../model/MenuItemModel.js");

let main = function (Backbone, MenuItemModel) {
    return Backbone.Collection.extend({
        model: MenuItemModel,
        url: 'menuItem/list',

        getAvailableItemCollection: function (status) {
            var params = {status: 'Available'};
            if(status=="father"){
                params.parentId = undefined;
            }
            return new Backbone.Collection(this.where(params));
        },

        getSoldOutItemCollection: function (status) {
            var params = {status: 'SoldOut'};
            if(status=="father"){
                params.parentId = undefined;
            }
            return new Backbone.Collection(this.where(params));
        }
    });
};

let exportedValue = main(Backbone, MenuItemModel);
module.exports = exportedValue;



// WEBPACK FOOTER //
// ./src/collection/MenuItemCollection.js